import FullTextSearchResult from './FullTextSearchResult';

export default FullTextSearchResult;
